import { Component, input, InputSignal } from "@angular/core";
import { FeltAlternativ, FeltRadioComponent, FormRoot } from "@husbanken/designsystem-angular-forms";
import { FormControl, ReactiveFormsModule } from "@angular/forms";

/**
 * Component for single-choice questions.
 * Used when exactly **one** alternative should be selected.
 */
@Component({
  selector: "bko-envalg-sporsmal",
  imports: [FeltRadioComponent, ReactiveFormsModule],
  templateUrl: "./envalg.html",
  styleUrl: "./envalg.scss",
})
export class Envalg {
  readonly alternatives: InputSignal<FeltAlternativ[]> = input([
    { key: "0", tekst: "Ja" },
    { key: "1", tekst: "Delvis" },
    { key: "2", tekst: "Nei" },
  ]);
  form = input.required<FormRoot<{ control: FormControl }>>();
  legendText = "Velg et alternativ";
}
